import styled from '@emotion/styled';

export const PersonsOffshoreChartBase = styled.div`
    background-color: ${(p) => p.theme.color.grayDark3};
    width: 100%;
    display: flex;
    flex-direction: column;
`;

export const ItemsContainer = styled.div`
    display: flex;
    min-width: 500px;
    justify-content: space-between;
`;
